import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {DipRegistrationOverviewComponent} from './dip-registration-overview/dip-registration-overview.component';
import {DipRegistrationCustomerIdentificationComponent} from './dip-registration-customer-identification/dip-registration-customer-identification.component';
import {DipRegistrationContextGuardService} from './core/services/guards/dip-registration-context-guard.service';
import {DipRegistrationExistingAccountComponent} from './dip-registration-existing-account/dip-registration-existing-account.component';
import {DipRegistrationSessionExpiredComponent} from './dip-registration-session-expired/dip-registration-session-expired.component';
import {DipRegistrationCloseGuardService} from './core/services/guards/dip-registration-close-guard.service';
import {DipRegistrationPhoneNumberListComponent} from './dip-registration-phone-number-list/dip-registration-phone-number-list.component';
import {DipRegistrationApplicationErrorComponent} from './dip-registration-error/dip-registration-application-error/dip-registration-application-error.component';
import {DipRegistrationOverviewResolver} from './dip-registration-overview/dip-registration-overview-resolver.service';
import {DipRegistrationRestartGuardService} from './core/services/guards/dip-registration-restart-guard.service';
import {DipRegistrationPageNotFoundErrorComponent} from './dip-registration-error/dip-registration-page-not-found-error/dip-registration-page-not-found-error.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'overview',
    pathMatch: 'full'
  },
  {
    path: 'overview',
    component: DipRegistrationOverviewComponent,
    data: {tagInformation: 'overviewTag'},
    canActivate: [DipRegistrationContextGuardService],
    resolve: {
      context: DipRegistrationOverviewResolver
    }
  },
  {
    path: 'customer-identification',
    component: DipRegistrationCustomerIdentificationComponent,
    data: {tagInformation: 'customerInfoTag'},
    canActivate: [DipRegistrationContextGuardService],
    canDeactivate: [DipRegistrationCloseGuardService]
  },
  {
    path: 'phone-number-list',
    component: DipRegistrationPhoneNumberListComponent,
    data: {tagInformation: 'confirmYourNumberTag'},
    canActivate: [DipRegistrationContextGuardService],
    canDeactivate: [DipRegistrationCloseGuardService]
  },
  {
    path: 'existing-account',
    component: DipRegistrationExistingAccountComponent,
    data: {tagInformation: 'existingAccountTag'},
    canActivate: [DipRegistrationContextGuardService],
    canDeactivate: [DipRegistrationRestartGuardService]
  },
  {
    path: 'session-expired',
    component: DipRegistrationSessionExpiredComponent,
    data: {tagInformation: 'sessionExpiredTag'},
    canActivate: [DipRegistrationContextGuardService],
    canDeactivate: [DipRegistrationRestartGuardService]
  },
  {
    path: 'applicationError', component: DipRegistrationApplicationErrorComponent,
    canDeactivate: [DipRegistrationRestartGuardService]
  },
  {
    path: '**', component: DipRegistrationPageNotFoundErrorComponent,
    canDeactivate: [DipRegistrationRestartGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false,
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload',
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled'
})],
  exports: [RouterModule]
})
export class DipRegistrationRoutingModule {
}
